


















































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import QueryBuilder from 'query-builder-vue';
import RuleInput from '@/components/conditionbuilder/RuleInput.vue';
import Rule from '@/components/conditionbuilder/Rule.vue';
import {DeviceVersionRule, JSONRule, RuleConditions, SchemaField} from '@/types';

@Component({
  components: {
    QueryBuilder,
    RuleInput,
    Rule,
  },
})
export default class Rules extends Vue {
  @Prop() private deviceType: any;
  @Action private addToastErrorMessage: any;
  @Action private addRulesAsync: any;
  @Action private removeRuleAsync!: (id: number) => DeviceVersionRule;
  @Action private createRuleAsync!: (rule: object) => DeviceVersionRule;
  @Action private updateRuleAsync!: (rule: object) => DeviceVersionRule;
  @Action private addUplinkSchemasAsync: any;
  @Getter private deviceRules: any;
  @Getter private deviceUplinkSchemas: any;

  private showDialog: boolean[] = [];
  private preventSave: boolean = true;
  private dragging: boolean = true;
  private validate: number = 0;
  private hasOperator: boolean = false;
  private hasChildren: boolean = false;
  private selectedMessageType: string = '';
  private nameError: boolean = false;

  private messageTypes: any[] = [];
  private rules: any[] = [];
  private currentRulePanel: number = -1;
  private severity: string[] = ['info', 'warning', 'critical'];

  private query: any = null;
  private config: any =  {
    operators: [
      { name: '', identifier: '' },
      { name: 'ANY', identifier: 'ANY' },
      { name: 'ALL', identifier: 'ALL' },
    ],
    rules: [],
    dragging: {
      animation: 300,
      disabled: !this.dragging,
      dragClass: 'sortable-drag',
    },
  };

  @Watch('query')
  private onQueryChange(query: any) {
    this.validate++;
    if (query && query.children && query.children.length) {
      return this.hasChildren = true;
    } else {
      return this.hasChildren = false;
    }
  }

  private async mounted() {
    if (this.deviceType) {
      if (!this.messageTypes || !this.messageTypes.length) {
        if (!(await this.addUplinkSchemasAsync(this.deviceType.id))) {
          return;
        }

        const messages = this.deviceUplinkSchemas;
        Vue.set(this, 'messageTypes', this.groupMessageTypes(messages));
      }

      if (!(await this.addRulesAsync(this.deviceType.id))) {
        return;
      }

      this.rules = [...this.deviceRules];
    }
  }

  private checkForAddRule() {
    if (this.messageTypes[0]) {
      Vue.set(this.showDialog, this.rules.length, true);

      this.addRule();
    } else {
      this.addToastErrorMessage('No available message types for this device type.');
    }
  }

  private checkForRemoveRule(rule: DeviceVersionRule) {
    if (!rule.id) {
      this.removeRule();
    }
  }

  private async addRule() {
    this.query = null;
    this.hasOperator = false;

    const newRule = {
      device_version_id: this.deviceType.id,
      conditions: {
        operatorIdentifier: '',
        children: {},
      },
      name: '',
    };
    this.rules.push(newRule);
    this.currentRulePanel = this.rules.length - 1;
  }

  private populateRule(rule: any) {
    if (typeof rule.id !== 'undefined') {
      if (rule.conditions && rule.conditions.children && Object.values(rule.conditions.children).length) {
        for (const c of rule.conditions.children) {

          this.hasOperator = true;

          const dbRule = {
            identifier: 'field',
            name: '',
            component: RuleInput,
            initialValue: () => {
              return {
                fact: '',
                path: '',
                operation: '',
                value: null,
              };
            },
          };
          this.config.rules.push(dbRule);
        }
        this.query = rule.conditions;
        this.getFields(rule);
      }
    } else {
      this.query = null;
    }
  }

  private groupMessageTypes(messages: SchemaField[], selected = '') {
    const grouped = messages.reduce((acc: any, d) => {
      if (Object.keys(acc).includes(d.message_type)) { return acc; }

      acc[d.message_type] = messages.filter((g: SchemaField) => g.message_type === d.message_type);
      return acc;
    }, {});

    const groupedMessages: any[] = [];
    for (const key in grouped) {
      if (grouped.hasOwnProperty(key)) {
        const obj = {name: key, messages: grouped[key]};
        groupedMessages.push(obj);
      }
    }
    if (!selected) {
      return groupedMessages;
    } else {
      return groupedMessages.filter((messageType: any) => messageType.name === selected);
    }

  }

  private getFields(rule: any) {
    this.selectedMessageType = rule.message_type;

    let metricsForMessageType = this.messageTypes.filter((type) => type.name === rule.message_type);
    metricsForMessageType = metricsForMessageType.flatMap((type) => type.messages.map((field: SchemaField) => ({ name: field.fieldName })));

    const currRule = this.rules.find((r) => {
      if (rule.id) {
        return r.id === rule.id;
      } else {
        Vue.set(rule, 'metrics', metricsForMessageType);
        return false;
      }
    });

    if (currRule) {
      Vue.set(currRule, 'metrics', metricsForMessageType);
    }
  }

  private async saveRules() {
    this.rules.forEach(async (r: any, i: number) => {
      const currentRule: DeviceVersionRule = {
        name: r.name,
        desc: r.desc,
        device_version_id: this.deviceType.id,
        conditions: {},
        message: r.message,
        severity: r.severity,
        message_type: r.message_type ? r.message_type : this.messageTypes[0].name,
      };

      if (r.id) {
        if (this.currentRulePanel !== i) {
          currentRule.conditions = r.conditions;
        } else {
          currentRule.conditions = this.query;
        }
        if (!(await this.updateRuleAsync({id: r.id, body: currentRule}))) {
          return;
        }
      } else {
        if (currentRule.name) {
          currentRule.conditions = this.query;

          const rule = await this.createRuleAsync({deviceId: this.deviceType.id, body: currentRule});
          if (!rule) {
            return;
          }
          if (!await this.addRulesAsync(this.deviceType.id)) {
            return;
          }

          this.rules = [...this.deviceRules];
          if (r.message_type) {
            this.getFields(this.rules.find((ru) => ru.id === rule.id));
          } else {
            this.rules[this.rules.length - 1].message_type = '';
          }
        }
      }
    });
    this.$emit('saveDeviceType', this.deviceType);
  }

  private addCondition(props: any) {
    let condition = {};
    if (this.selectedMessageType !== '') {
      condition = {
        identifier: 'field',
        name: '',
        component: RuleInput,
        initialValue: () => { return {
          fact: '',
          path: '',
          operation: '',
          value: null,
        }; },
      };
      this.config.rules.push(condition);
    }
    props.addRule('field');
  }

  private async removeRule(id?: number | undefined) {
    if (id) {
      if (!(await this.removeRuleAsync(id))) {
        return;
      }
    }
    this.rules = this.rules.filter((rule: any) => rule.id !== id);
  }

  private get nameRules() {
    const rules: any[] = [];

    rules.push(
      (v: string) => !!v || 'Event name is required',
      (v: string) => {
        if (this.rules.filter((n) => n.name === v).length > 1) {
          this.nameError = true;
          return `Name "${v}" already exists`;
        } else {
          this.nameError = false;
          return true;
        }
      });
    return rules;

  }

  private checkName(rule: any, i: number) {
    Vue.set(this.showDialog, i, false);
  }

  private preventSaving(prevented: boolean) {
    this.preventSave = prevented;
  }
}
